import { render, staticRenderFns } from "./ManagerGameType.vue?vue&type=template&id=1ef4405f&scoped=true&"
import script from "./ManagerGameType.vue?vue&type=script&lang=js&"
export * from "./ManagerGameType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4405f",
  null
  
)

export default component.exports